import { defineComponent as _defineComponent } from 'vue'
import { BotMetadata } from '@/entities/conversation'
import { timestampToDateTime } from '@/utils/time'

interface Props {
    botMetadata: BotMetadata
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatResponseBotMetadata',
  props: {
    botMetadata: null
  },
  setup(__props: any) {

const props = __props as {
    botMetadata: BotMetadata
}



return { __sfc: true,props, timestampToDateTime }
}

})